(function() {
  var STORAGE_KEY = 'tsn_cart_terms_agreed_at';
  var EXPIRY_MS = 15 * 60 * 1000; // 15 minutes

  function isAgreementFresh() {
    try {
      var ts = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      if (!ts) return false;
      return (Date.now() - ts) < EXPIRY_MS;
    } catch (e) { return false; }
  }

  function rememberAgreement() {
    try { localStorage.setItem(STORAGE_KEY, Date.now().toString()); } catch (e) {}
  }

  function clearAgreement() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  // Auto-tick any terms checkbox on the page if agreement is fresh
  function syncCheckboxes() {
    var fresh = isAgreementFresh();
    var boxes = document.querySelectorAll('#cart-terms, .js-cart-terms-checkbox');
    boxes.forEach(function(b) {
      if (fresh && !b.checked) {
        b.checked = true;
        b.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    var warning = document.querySelector('.cart-drawer__terms-warning');
    if (warning && fresh) warning.hidden = true;
  }

  document.addEventListener('DOMContentLoaded', syncCheckboxes);

  // Re-sync when the cart drawer opens (drawer may render after page load)
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-action="open-drawer"], .js-open-drawer, [href="#cart-drawer"], .header__cart-link, .js-toggle-cart-drawer')) {
      setTimeout(syncCheckboxes, 100);
    }
  });

  // When ANY terms checkbox is ticked, remember it
  document.addEventListener('change', function(e) {
    if (e.target && (e.target.id === 'cart-terms' || e.target.classList.contains('js-cart-terms-checkbox'))) {
      if (e.target.checked) {
        rememberAgreement();
        syncCheckboxes();
        var warning = document.querySelector('.cart-drawer__terms-warning');
        if (warning) warning.hidden = true;
      } else {
        clearAgreement();
      }
    }
  });

  // Gate any drawer link that requires agreement
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.js-drawer-checkout-link');
    if (!link) return;
    if (isAgreementFresh()) return;
    var checkbox = document.querySelector('#cart-terms');
    if (checkbox && checkbox.checked) {
      rememberAgreement();
      return;
    }
    e.preventDefault();
    var warning = document.querySelector('.cart-drawer__terms-warning');
    if (warning) warning.hidden = false;
    if (checkbox) checkbox.focus();
  });

  // Clear the flag once an order is placed
  if (/\/(thank_you|orders\/)/.test(window.location.pathname)) {
    clearAgreement();
  }
})();